import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Checkbox } from 'redux-form-material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import { PORT_WAREHOUSE_TYPES } from 'constants/ports';
import './Warehouses.scss';

const WarehousesForm = ({ handleSubmit, onCancel }) => (
    <div className="warehouses-block">
        <div className="warehouses-grid">
            {PORT_WAREHOUSE_TYPES.map(({ name, label }) => (
                <div key={name} className="warehouse-item">
                    <Field
                        name={`warehouses.${name}`}
                        component={Checkbox}
                        label={label}
                    />
                </div>
            ))}
        </div>
        <div className="form-actions">
            <RaisedButton
                label="Save"
                primary
                onClick={handleSubmit}
            />
            <RaisedButton
                label="Cancel"
                secondary
                onClick={onCancel}
            />
        </div>
    </div>
);

export default reduxForm({
    form: 'warehousesForm',
    enableReinitialize: true,
})(WarehousesForm);



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/Warehouses/WarehousesForm.jsx